import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import BootstrapVue from 'bootstrap-vue'
import VueLazyload from 'vue-lazyload'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'

import App from './App.vue'
import store from './store'
import '@/styles/main.scss'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueLazyload)
Vue.use(require('vue-scrollto'))

Vue.component('date-pick', DatePick)

// Require in a base component context
const requireComponent = require.context(
  '@/components', false, /base-[\w-]+\.vue$/
)
requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )

  // Register component globally
  Vue.component(componentName, componentConfig.default || componentConfig)
})

/*
Vue.mixin({
  data: function() {
    return {
      _: require('lodash'),
    }
  }
})
*/

new Vue({
  render: h => h(App),
  store,
}).$mount('#app')
